import moment from 'moment'

export default {
  namespaced: true,
  state: {
    iso: moment().local().format(),
  },
  getters: {
    startOfDay: (state) =>
      state.iso ? moment(state.iso).startOf('day').utc().format() : null,
    endOfDay: (state) =>
      state.iso ? moment(state.iso).endOf('day').utc().format() : null,
  },
  mutations: {
    iso(state, iso) {
      state.iso = iso
    },
  },
}
